document.addEventListener('DOMContentLoaded', function () {
  // mainタグにp-contact.jaクラスが付いているかを確認
  const mainElement = document.querySelector(".p-contact.ja");
  if (mainElement) {
    //日本語
    const contactMethodRadioButtons = document.querySelectorAll('input[name="method01"]');
    const telField = document.querySelector('input[name="tel01"]');
    const telFieldError = document.createElement('span');
    telFieldError.style.color = '#dc3232';
    telFieldError.textContent = '「お電話」を選択した場合は、電話番号を入力してください。';
    telFieldError.style.display = 'none'; // 初期状態では非表示

    // 電話番号フィールドの親要素にエラーメッセージを追加
    telField.parentElement.appendChild(telFieldError);

    contactMethodRadioButtons.forEach(function(radioButton) {
      radioButton.addEventListener('change', function() {
        if (this.value === 'お電話' && this.checked) {
          if (!telField.value) {
            telFieldError.style.display = 'block'; // エラーメッセージを表示
          }
        } else {
          telFieldError.style.display = 'none'; // エラーメッセージを非表示
        }
      });
    });
    // 電話番号フィールドに入力があった場合にエラーメッセージを非表示にする
    telField.addEventListener('input', function() {
      if (telField.value) {
        telFieldError.style.display = 'none';
      }
    });
  }
  // mainタグにp-contact.enクラスが付いているかを確認
  const mainElementEn = document.querySelector(".p-contact.en");
  if (mainElementEn) {
    // 英語
    const contactMethodRadioButtonsEn = document.querySelectorAll('input[name="method01-en"]');
    const telFieldEn = document.querySelector('input[name="tel01-en"]');
    const telFieldErrorEn = document.createElement('span');
    telFieldErrorEn.style.color = '#dc3232';
    telFieldErrorEn.textContent = 'If you selected “Telephone,” please enter your telephone number.';
    telFieldErrorEn.style.display = 'none'; // 初期状態では非表示

    // 電話番号フィールドの親要素にエラーメッセージを追加
    telFieldEn.parentElement.appendChild(telFieldErrorEn);

    contactMethodRadioButtonsEn.forEach(function (radioButton) {
      radioButton.addEventListener('change', function () {
        if (this.value === 'Telephone' && this.checked) {
          if (!telFieldEn.value) {
            telFieldErrorEn.style.display = 'block'; // エラーメッセージを表示
          }
        } else {
          telFieldErrorEn.style.display = 'none'; // エラーメッセージを非表示
        }
      });
    });
    // 英語版の電話番号フィールドに入力があった場合にエラーメッセージを非表示にする
    telFieldEn.addEventListener('input', function () {
      if (telFieldEn.value) {
        telFieldErrorEn.style.display = 'none';
      }
    });
  }
  // お見積り依頼
  // mainタグにp-estimateクラスが付いているかを確認
  const mainElement2 = document.querySelector(".p-estimate");
  if (mainElement2) {
    jQuery(document).ready(function ($) {
      // デフォルトのカレンダーを非表示にする
      $('.wpcf7-date').datepicker('destroy');
      // カスタムカレンダーを設定
      $('.custom-date').datepicker({
        showButtonPanel: true,
        changeMonth: true,
        changeYear: true,
        dateFormat: 'yy-mm-dd',
        beforeShow: function (input, inst) {
          $('#ui-datepicker-div').addClass('custom-calendar');
        }
      });
      // カレンダーアイコンを追加
      $('.custom-date').each(function () {
        var $this = $(this);
        $this.wrap('<div class="custom-calendar-icon"></div>');
      });
    });
    // ご利用目的の処理
    const contactUseRadioButtons = document.querySelectorAll('input[name="use01"]');
    const otherField = document.querySelector('input[name="other01"]');
    const otherFieldError = document.createElement('span');
    otherFieldError.style.color = '#dc3232';
    otherFieldError.textContent = '「その他」を選択した場合は、ご利用目的を入力してください。';
    otherFieldError.style.display = 'none'; // 初期状態では非表示
    // その他フィールドの親要素にエラーメッセージを追加
    otherField.parentElement.appendChild(otherFieldError);
    contactUseRadioButtons.forEach(function(radioButton) {
      radioButton.addEventListener('change', function() {
      if (this.value === 'その他' && this.checked) {
        if (!otherField.value) {
          otherFieldError.style.display = 'block'; // エラーメッセージを表示
        }
        } else {
          otherFieldError.style.display = 'none'; // エラーメッセージを非表示
        }
      });
    });
    // その他フィールドに入力があった場合にエラーメッセージを非表示にする
    otherField.addEventListener('input', function() {
      if (otherField.value) {
        otherFieldError.style.display = 'none';
      }
    });
    //会社名の処理
    const contactTypeRadioButtons = document.querySelectorAll('input[name="type01"]');
    const companyField = document.querySelector('input[name="company01"]');
    const companyFieldError = document.createElement('span');
    companyFieldError.style.color = '#dc3232';
    companyFieldError.textContent = '「会社」を選択した場合は、会社名を入力してください。';
    companyFieldError.style.display = 'none'; // 初期状態では非表示
    // 会社名フィールドの親要素にエラーメッセージを追加
    companyField.parentElement.appendChild(companyFieldError);
    contactTypeRadioButtons.forEach(function (radioButton) {
      radioButton.addEventListener('change', function () {
        if (this.value === '会社' && this.checked) {
          if (!companyField.value) {
            companyFieldError.style.display = 'block'; // エラーメッセージを表示
          }
        } else {
          companyFieldError.style.display = 'none'; // エラーメッセージを非表示
        }
      });
    });
    // 会社名フィールドに入力があった場合にエラーメッセージを非表示にする
    companyField.addEventListener('input', function () {
      if (companyField.value) {
        companyFieldError.style.display = 'none';
      }
    });
  }
});